import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService, ExportTaskProcessor } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { OrderDetailAttributes } from '@albatrosdeveloper/ave-models-package';
import { LostSaleService } from '../../../lost-sale/lost-sale.service';
import { DELIVERY_INCOMPLETE_EXPORT_ID, DELIVERY_INCOMPLETE_TITLE, LOCALIZED_PROPERTIES } from './delivery-incomplete.constants';
import { DeliveryIncompleteService } from '../delivery-incomplete.service';

@Injectable()
export class DeliveryIncompleteExport {
  constructor(
    private exportService: ExportService,
    private deliveryIncompleteService: DeliveryIncompleteService,
  ) {}

  private transformItem(item: OrderDetailAttributes) {
    return {
      trip: get(item, "trip.id", ''),
      code: get(item, "subRoute.externalKeys.code", ""),
      subRoute: get(item, "subRoute.name", ""),
      user: get(item, "user", ""),    
      numberOrder: this.getNumberOrder(item),
      date: ExportTaskProcessor.types.excel.date(get(item, "date", null)),
      shipToExternalKeyCode: get(item, "shipToExternalKeyCode", ""),
      shipToName: get(item, 'shipToName', ''),
      materialCode: get(item, "materialName.externalKeys.code", ""),
      materialName: get(item, "materialName.name", ""),
      soldQuantitySuggested: get(item, 'soldQuantitySuggested', 0) ?? 0,
      deliveredQuantity: get(item, 'deliveredQuantityES', 0),
      deliveredMinusSuggested: (get(item, 'deliveredMinusSuggested', 0) ?? 0) ,
    };
  }

  private getNumberOrder(item: OrderDetailAttributes): string {
      const numberOrder = get(item, 'numberOrder', '').trim();
      const serials = get(item, 'serials', '').trim();
      return [numberOrder, serials].filter(Boolean).join(' - ') || '??';
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: DELIVERY_INCOMPLETE_EXPORT_ID,
      title: DELIVERY_INCOMPLETE_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(DELIVERY_INCOMPLETE_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.deliveryIncompleteService.findByFilter(buildQuery(
          seed(this.deliveryIncompleteService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(DELIVERY_INCOMPLETE_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(DELIVERY_INCOMPLETE_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
